import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import UploadForm from './components/UploadForm';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <UploadForm />
    </ThemeProvider>
  );
}

export default App;